import React, { useEffect, useState } from 'react'
import {useQuery} from "../../../shared/hooks/useQuery";

const KUSuperAppOAuthCallback = (props) => {
    const [query, search] = useQuery();

      useEffect(() => {
        const code = query.get("code");
        const state = query.get("state");

        console.log('code', code)
        console.log('state', state)

        if (code) {
          //const deeplink = `kusuperappoauth://`;
          const deeplink = `th.ac.ku.kusuperapp://sso-dev-callback?code=${encodeURIComponent(code)}${state ? `&state=${encodeURIComponent(state)}` : ""}`;
          //const deeplink = `https://my-ku-phase2-uat.my-dev.co/myku/kusuperapp/oauth-callback/alllogin?code=${encodeURIComponent(code)}${state ? `&state=${encodeURIComponent(state)}` : ""}`;
          window.location.href = deeplink;
        }
      }, []);

      return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h3>Connecting to open KU Super App. Please wait a moment.</h3>
          {/* <p>หากไม่ถูกนำทางโดยอัตโนมัติ <a href={process.env.REACT_APP_BASENAME}>คลิกที่นี่</a></p> */}

          
          <h6>เทส Pass OAuth params to Universal Link <a href={`https://my-ku-phase2-uat.my-dev.co/myku/kusuperapp/oauth-callback/alllogin?code=abc`}>คลิกที่นี่</a></h6>
          <h6>เทส Pass OAuth params to Deep Link <a href={`th.ac.ku.kusuperapp://sso-dev-callback?code=abc`}>คลิกที่นี่</a></h6>

          <h6>เทส Open App By Universal Link URL https://my-ku-phase2-uat.my-dev.co/myku/.... <a href={'https://my-ku-phase2-uat.my-dev.co/myku/kusuperapp/oauth-callback/alllogin?code=abc'}>คลิกที่นี่</a></h6>
          <h6>เทส Open App By Universal Link URL https://ku-super-app-uat.my-dev.co/oauth/.... <a href={'https://ku-super-app-uat.my-dev.co/oauth/sso-dev-callback?code=abc'}>คลิกที่นี่</a></h6>
          <h6>เทส Deeplink URL th.ac.ku.kusuperapp://sso-dev-callback <a href={`th.ac.ku.kusuperapp://sso-dev-callback?code=abc`}>คลิกที่นี่</a></h6>
        </div>
      );
}

export default KUSuperAppOAuthCallback